<template>

  <v-container fluid class="px-0 mt-0 page page-receiver-item">

    <!-- Notifications -->
    <div class="notification-area">
      <data-editor-feedback
          resource="receiver"
          :autoCloseAfterMillis="5000" />
    </div>

    <!-- Page Content -->
    <v-container fluid>
      <transition name="fade-flash" mode="out-in">
        <router-view />
      </transition>
    </v-container>

  </v-container>

</template>

<script>
import DataEditorFeedback from '@/components/app/DataEditorFeedback'

export default {
  name: 'ReceiverRootPage',

  components: {
    DataEditorFeedback
  },

  props: {
    receiverId: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
</style>
